module.exports = __webpack_public_path__ + "media/images/flags/64/Mozambique-ec750b5c343551bec3d3bf1d25a6dcb1.png";